import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { SKIP_SPINNER } from '../core/_utils/httpcontext';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private isSkipGlobalSpinner:boolean = false;
  constructor(private loaderService: LoaderService) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  checkChatRequest(req: HttpRequest<any>):boolean {
    var reqUrl =  req.url.split('/') as String[];
    
    return reqUrl.includes("message") || reqUrl.includes("notifications");
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.isSkipGlobalSpinner = this.checkChatRequest(req) || req.context.get(SKIP_SPINNER);
    
    if(!this.isSkipGlobalSpinner){
      this.requests.push(req);
      this.loaderService.isLoading.next(true);
    }
    // console.log("No of requests--->" + this.requests.length);

    
    return Observable.create(observer => {
      const subscription = next.handle(req)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
            this.removeRequest(req);
            observer.error(err);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
